/* global axios */
import ApiClient from './ApiClient';

// Cliente da página de candidatos reprovados. Todas as chamadas vão para o proxy
// Rails (Api::V1::Accounts::CandidatesController), nunca para o n8n direto: o
// token não pode chegar ao navegador e a lista é dado pessoal (§4.2 da spec).
class CandidatesAPI extends ApiClient {
  constructor() {
    super('candidates', { accountScoped: true });
  }

  jobs() {
    return axios.get(`${this.url}/jobs`);
  }

  list(vaga) {
    return axios.get(this.url, { params: { vaga } });
  }

  dispatch(payload) {
    return axios.post(`${this.url}/dispatch`, payload);
  }
}

export default new CandidatesAPI();
